import { useEffect, useState } from 'react';

// Estado open/close del command-K global + el atajo de teclado que lo
// togglea. Bindea AMBOS atajos (Cmd+K y Ctrl+K) sin importar la plataforma
// detectada — el label visual del trigger (⌘K vs Ctrl K) es lo único que
// varía por plataforma (ver lib/platform.ts); el handler es el mismo.
// Portado de RISIT tal cual (MVP B.1 punto 3).
export function useGlobalSearchShortcut() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent): void {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen(v => !v);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { open, setOpen };
}
